export default {"src":"/_next/static/media/checkpurple.e6fb25fa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};